export default "__VITE_ASSET__CI8N5Zu2__"